import { orderBy } from "lodash";
import { CBSaltospi } from "../../../services/api";

export async function fetchProvasFiltradas({
  idEvento,
  tipoAparelho,
  sexo,
  idClasse,
}) {
  const res = await CBSaltospi.get("evento-prova", {
    params: {
      id_evento: idEvento,
      "aparelho.tipo_aparelho": tipoAparelho,
      sexo: sexo,
      id_classe: idClasse,
      expand: "classificacao,aparelho,classe,altura",
      pageSize: 50,
    },
  });

  if (res.data._meta.totalCount === 0) {
    return [];
  }

  // Sort by apparatus creation date and height description
  return orderBy(
    res.data.items,
    ["aparelho.created_at", "altura.descricao"],
    ["asc", "asc"]
  );
}
